import { render } from "./FollowRecord.vue?vue&type=template&id=e3373b14&scoped=true"
import script from "./FollowRecord.vue?vue&type=script&lang=js"
export * from "./FollowRecord.vue?vue&type=script&lang=js"

import "./FollowRecord.vue?vue&type=style&index=0&id=e3373b14&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3373b14"]])

export default __exports__